import { useNavigate, useParams } from 'react-router-dom';
import { HandleKindSchema } from '@pomoshnik/shared';
import { ShopsList } from './ShopsList';

/**
 * Thin wrapper для маршрута `/handles/:kind/:globalId/shops` (Block 4).
 *
 * Читает URL params, парсит kind через Zod (fallback на 'handle' при невалидном
 * значении — соответствует поведению до Phase 8), декодирует globalId
 * (verbatim P-001) и пробрасывает в shared-Container `<ShopsList />`.
 *
 * Per ADR-0007 — wrapper живёт рядом с Container, чтобы router.tsx остался
 * плоским списком роутов без inline-функций.
 */
export function HandlesShopsRoute() {
  const navigate = useNavigate();
  const params = useParams<{ kind: string; globalId: string }>();
  const subKind = HandleKindSchema.safeParse(params.kind).data ?? 'handle';
  // react-router-dom v7 уже декодирует path params; повторный
  // decodeURIComponent ломается на Global_ID с `%` (URIError).
  const globalId = params.globalId ?? '';
  return (
    <ShopsList
      entityKind="handle"
      subKind={subKind}
      globalId={globalId}
      onBackToCard={() => navigate(`/handles/${subKind}/${encodeURIComponent(globalId)}`)}
    />
  );
}
